export default "__VITE_ASSET__e4e500e9__"